import {BUS_EVENT_TASK_VIEW_OPEN} from "../../../src/core/gd/task-view/@const"

export default class GDSharedTaskView {
    open(taskId: ID) {
        const path = window.location.pathname.split('/')
        const url = "{0}/t/{1}".f(path[1], taskId)

        if (!url.includes("TEMP_ID")) {
            gd.goTo(url)
        } else {
            console.log("GDSharedTaskView: task is not yet fully added", url)
        }

        gd.bus.triggerEvent(BUS_EVENT_TASK_VIEW_OPEN, taskId)
    }
}